<template>
  <div class="chart" ref="line"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      widthPix: 1,
    };
  },
  props: {
    showLegend: {
      default: true,
    },
    yName: {
      default: "单位：人",
    },
  },
  methods: {
    initChart(series, category) {
      let myChart = null;
      if (myChart != null && myChart != "" && myChart != undefined) {
        myChart.dispose();
      }
      var chartDom = this.$refs.line;
      myChart = echarts.init(chartDom);
      var option;
      option = {
        legend: {
          show: this.showLegend,
          right: 0 * this.widthPix,
          top: 0 * this.widthPix,
          itemWidth: 12 * this.widthPix,
          itemHeight: 2 * this.widthPix,
          itemGap: 30 * this.widthPix,
          textStyle: {
            color: "#BDCDE4",
            fontSize: 12 * this.widthPix,
          },
        },
        xAxis: {
          type: "category",
          data: category,

          axisTick: {
            show: false,
          },

          axisLabel: {
            color: "#FFFFFF",
            fontSize: 12 * this.widthPix,
            // rotate: -50,
            interval: 0,
            lineHeight: 20 * this.widthPix,
            formatter: (value) => {
              const labelValue1 = value.substr(0, 6);
              const labelValue2 = value.substr(6);
              // for (let i = 0; i < Math.ceil(value.length / 6); i++) {
              //   const sub = 6 * i;
              //   if (labelValue) {
              //     labelValue = labelValue + "\n" + value.substr(sub, 6);
              //   } else {
              //     labelValue = value.substr(sub, 6);
              //   }
              // }
              return labelValue2
                ? labelValue1 + "\n" + labelValue2
                : labelValue1;
            },
          },
          aixsLine: {
            show: false,
            lineStyle: {
              color: "#3C5787",
            },
          },
        },

        yAxis: {
          type: "value",
          name: this.yName,
          nameGap: 19,
          nameTextStyle: {
            color: "#AEC3DC",
            fontSize: 12,
          },
          // max:100,
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(178, 194, 211, 0.2)",
            },
          },
          aixsLine: {
            show: true,
            lineStyle: {
              color: "#3C5787",
            },
          },
          axisLabel: {
            color: "#6887A5",
            fontSize: 14 * this.widthPix,
          },
        },
        grid: {
          left: 40 * this.widthPix,
          right: 0 * this.widthPix,
          top: 40 * this.widthPix,
          bottom: 50 * this.widthPix,
        },
        barWidth: 6 * this.widthPix,
        series: series,
      };
      myChart.clear();
      option && myChart.setOption(option);
    },
  },
  mounted() {
    this.widthPix =
      window.screen.width < 1920 ? 1 : Math.floor(window.screen.width / 1920);
    // this.initChart();
  },
};
</script>
<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
